import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';

import { PantallaCarga } from '@/components/PantallaCarga';
import { env } from '@/lib/env';

import { destinoLegacy } from './redirecciones';

/** Rutas viejas del PHP (`/inicio/...`, `/legacy/...`): ver `redirecciones.ts`. */
export function RedireccionLegacy() {
  const { pathname, search } = useLocation();
  const destino = destinoLegacy(pathname, search, env.legacyUrl);
  useEffect(() => {
    if (destino.tipo === 'externa') window.location.replace(destino.url);
  }, [destino]);
  if (destino.tipo === 'externa') return <PantallaCarga />;
  return <Navigate to={destino.ruta} replace />;
}
